import { useAuth0 } from '@auth0/auth0-react';
import { UserNavBar } from './UserNavBar';
import { SafeguardNavBar } from './SafeguardNavBar';
import { LoadingNavBar } from './LoadingNavBar';
import { useUserContext } from '../../context_providers/user_context/UserProvider';
import EmergencyBanner from '../banners/emergency_banner/EmergencyBanner';

const NavBar = () => {
  const { isAuthenticated } = useAuth0();
  const { safeguardView } = useUserContext();

  return (
    <div>
      {isAuthenticated ? (
        !safeguardView ? (
          <>
            <UserNavBar />
            <EmergencyBanner />
          </>
        ) : (
          <>
            <SafeguardNavBar />
          </>
        )
      ) : (
        <LoadingNavBar />
      )}
    </div>
  );
};

export default NavBar;
